export default function StatCard({ label, value, icon: Icon, accent = "walnut", testId }) {
    return (
        <div data-testid={testId} className="bg-white dark:bg-[#171311] border border-stone-border dark:border-stone-800 p-5 md:p-6 flex items-start justify-between">
            <div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-stone-muted dark:text-stone-400">{label}</div>
                <div className="font-serif text-4xl md:text-5xl mt-2 text-ink dark:text-stone-100">{value ?? "—"}</div>
            </div>
            {Icon && (
                <div className={`w-10 h-10 flex items-center justify-center bg-${accent}/10 text-${accent}`}>
                    <Icon size={20} className="text-walnut" />
                </div>
            )}
        </div>
    );
}
